export default __webpack_public_path__ + "static/media/StadisticsIcon.d30d615d.svg";